import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = JSON.parse(sessionStorage.getItem('userIdToken'));
    // console.log('interceptor token', token);
    if (!token) {
        return next.handle(req);
        }
    const headers = req.clone({
        headers: req.headers.set('authorization', `${token}`)
        });
    return next.handle(headers);
  }
}
